import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Menu, Item, Separator } from 'react-contexify';

import 'react-contexify/dist/ReactContexify.css';
import { makeStyles } from '@material-ui/core/styles';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SyncIcon from '@material-ui/icons/Sync';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import HomeIcon from '@material-ui/icons/Home';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import InsertLinkIcon from '@material-ui/icons/InsertLink';
import FileCopyIcon from '@material-ui/icons/FileCopyOutlined';
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles(theme => ({
  menu: {
    zIndex: 1200
  },
  iconStyle: {
    color: 'inherit',
    marginRight: '5px'
  },
  menuItem: {
    '& > .react-contexify__item__content > svg': {
      color: theme.palette.primary.main
    },
    '&:hover > .react-contexify__item__content  > svg': {
      color: '#fff'
    }
  }
}));
const TABS_CONTEXT_MENU_ID = 'TABS_CONTEXT_MENU_ID';

const TabsContextMenu = memo(
  ({
    handleItemClick,
    isDefaultTemplate,
    handleAnchorItemClick,
    handleCopyItemClick,
    handleSetHomepageClick
  }) => {
    const classes = useStyles();
    return (
      <Menu className={classes.menu} id={TABS_CONTEXT_MENU_ID}>
        <Item onClick={handleItemClick} className={classes.menuItem} data="insert_before">
          <UndoIcon className={classes.iconStyle} /> Insert Tab Before
        </Item>
        <Item onClick={handleItemClick} className={classes.menuItem} data="insert_after">
          <RedoIcon className={classes.iconStyle} /> Insert Tab After
        </Item>
        <Item onClick={handleItemClick} className={classes.menuItem} data="replace">
          <SyncIcon className={classes.iconStyle} /> Replace Tab
        </Item>
        <Item onClick={handleItemClick} className={classes.menuItem} data="swap">
          <SwapHorizontalCircleIcon className={classes.iconStyle} /> Swap Tab
        </Item>
        <Separator />
        <Item onClick={handleItemClick} className={classes.menuItem} data="delete">
          <DeleteForeverIcon className={classes.iconStyle} /> Remove Tab
        </Item>
        {!isDefaultTemplate && (
          <Item onClick={handleItemClick} className={classes.menuItem} data="reset">
            <SettingsBackupRestoreIcon className={classes.iconStyle} /> Reset to defaults
          </Item>
        )}
        <Separator />
        <Item onClick={handleSetHomepageClick} className={classes.menuItem} data="set_homepage">
          <HomeIcon className={classes.iconStyle} /> Set As Homepage
        </Item>
        <Item onClick={handleAnchorItemClick} className={classes.menuItem} data="target_blank">
          <InsertLinkIcon className={classes.iconStyle} />
          Open in new tab
        </Item>
        <Item onClick={handleItemClick} className={classes.menuItem} data="save">
          <SaveIcon className={classes.iconStyle} />
          Save Dashboard
        </Item>
        <Item onClick={handleCopyItemClick} className={classes.menuItem} data="copy">
          <FileCopyIcon className={classes.iconStyle} />
          Copy Link Address
        </Item>
      </Menu>
    );
  }
);

TabsContextMenu.propTypes = {
  isDefaultTemplate: PropTypes.bool.isRequired,
  handleItemClick: PropTypes.func.isRequired,
  handleAnchorItemClick: PropTypes.func.isRequired,
  handleCopyItemClick: PropTypes.func.isRequired,
  handleSetHomepageClick: PropTypes.func.isRequired
};

export default TabsContextMenu;
